module.exports = __webpack_public_path__ + "static/media/invalid-icon.fd60a460.svg";